/* @jsxRuntime classic */
/* @jsx React.createElement */
import React from "react";

import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import LegalNotice from "../pages/legal-notice/page";
import PrivacyPolicy from "../pages/privacy-policy/page";
import TermsOfService from "../pages/terms-of-service/page";
import AvailabilityPage from "../pages/availability/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/availability",
    element: <AvailabilityPage />,
  },
  {
    path: "/legal-notice",
    element: <LegalNotice />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicy />,
  },
  {
    path: "/terms-of-service",
    element: <TermsOfService />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
